export const FETCH_LINES_REQUEST = 'FETCH_LINES_REQUEST';
export const FETCH_LINES_SUCCESS = 'FETCH_LINES_SUCCESS';
export const FETCH_LINES_FAILURE = 'FETCH_LINES_FAILURE';

export const FETCH_LINE_REQUEST = 'FETCH_LINE_REQUEST';
export const FETCH_LINE_SUCCESS = 'FETCH_LINE_SUCCESS';
export const FETCH_LINE_FAILURE = 'FETCH_LINE_FAILURE';

export const UPDATE_LINES_REQUEST = 'UPDATE_LINES_REQUEST';
export const UPDATE_LINES_SUCCESS = 'UPDATE_LINES_SUCCESS';
export const UPDATE_LINES_FAILURE = 'UPDATE_LINES_FAILURE';

export const DELETE_LINES_REQUEST = 'DELETE_LINES_REQUEST';
export const DELETE_LINES_SUCCESS = 'DELETE_LINES_SUCCESS';
export const DELETE_LINES_FAILURE = 'DELETE_LINES_FAILURE';

export const CLEAR_LINE_ERRORS = 'CLEAR_LINE_ERRORS';
export const CLEAR_LINE_SUCCESS = 'CLEAR_LINE_SUCCESS';